// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__k_YSu","rotate":"Spinner_rotate__Gy4Gu","path":"Spinner_path__cs93V","dash":"Spinner_dash__ZSDdp"};